// @givmo/social — a scheduled post opened for editing keeps its time (SMM-WEB1; the 2026-11-03 user
// test, U13): Edit moves the post back to a draft (cancel, which clears its time on the server), so
// this tab remembers the time it was scheduled for and the composer's Schedule starts from it. Kept
// in this tab only, per post; never sent anywhere.

const KEY = 'givmo.social.reschedule';

function store(): Storage | null {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    return null;
  }
}

/** Remember the time a post was scheduled for, as it goes back to a draft. */
export function keepRescheduleTime(postId: string, iso: string | null | undefined): void {
  if (!iso) return;
  try {
    store()?.setItem(`${KEY}.${postId}`, iso);
  } catch {
    // Storage refused: the Schedule dialog then starts from its usual time.
  }
}

/** The time a post was scheduled for before it was opened for editing, or null. */
export function readRescheduleTime(postId: string): string | null {
  try {
    const value = store()?.getItem(`${KEY}.${postId}`) ?? null;
    return value !== null && !Number.isNaN(new Date(value).getTime()) ? value : null;
  } catch {
    return null;
  }
}

/** Forget it once the post is scheduled or published again. */
export function forgetRescheduleTime(postId: string): void {
  try {
    store()?.removeItem(`${KEY}.${postId}`);
  } catch {
    // Nothing to forget.
  }
}
